import React from "react"
import { Link, graphql } from 'gatsby'

import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import Features from '../components/Features'
import Format from '../components/Format'
import Footer from '../components/Footer'
import * as clampStyles from "../css/clamp.module.css"

import { FaCode } from "react-icons/fa";

export default function Home({ data }) {

	console.log( data );
	
	const blogs = data.allBlogJson.nodes;
	const tutorials = data.allTutorialsJson.nodes;

	return (
		<>
			<Navbar/>
			<Hero/>
			<LatestPosts blogs={ blogs }/>
			<TutorialSection tutorials={ tutorials }/>
			<Format/>
			<Footer/>
		</>
	)

}

function BlogCard( {blog} ) {
	
	const url = `/blog/${blog.shortId}/`;
	
	return (
		<div className="col-lg-4 col-md-6 mb-4">
			<div className="card">
				
				<div className="bg-image hover-overlay ripple" data-mdb-ripple-color="light">
					<img src={ blog.image } className="img-fluid" />
					<a href="#!">
						<div className="mask" style={{ backgroundColor : "rgba(251, 251, 251, 0.15)" }}></div>
					</a>
				</div>
				
				<div className="card-body">
					<h5 className="card-title">{ blog.title }</h5>
					<p className={clampStyles.lines + " card-text"} dangerouslySetInnerHTML={{ __html : blog.content }} />
					
					<Link to={ url }>
						<button className="btn btn-primary btn-lg">
							Read More
						</button>
					</Link>
					
				</div>
			</div>
		</div>
	)

}

function LatestPosts( {blogs} ) {

	console.log( blogs[0] );

	return (
		<section>
			<div className='container'>
				<h2 className='display-4 text-center my-4'>
					<span className='border-bottom'>Latest Posts</span>
				</h2>
				<div className="row">
					{ blogs.map( blog => {
						return <BlogCard key={ blog.shortId } blog={ blog } />
					})}
				</div>
			</div>
		</section>
	)
}

const TutorialCard = function({ tutorial }) {

	const url = `/${tutorial.slug}/`;
	
	return (
		<div className="row">
			<div className="col-md-5 mb-4">
				<div className="bg-image shadow-sm">
					<img src={ tutorial.card_image} className="img-fluid rounded" />
				</div>
			</div>

			<div className="col-md-7 mb-4">
				<h5 className='display-6'>{ tutorial.title }</h5>
				<p className='lead'>{ tutorial.description }</p>
				<Link to={ url }>
					<button type="button" className="btn btn-primary btn-lg">Read More</button>
				</Link>
			</div>
		</div>
	)

}

function TutorialSection({ tutorials }) {

	console.log( tutorials );

	return (
		<section>
			<div className='container'>
				<h2 className='display-4 text-center my-4'>
					<span className='border-bottom'>Latest Tutorials</span>
				</h2>
				
				{tutorials.map( tutorial => {
					return <TutorialCard key={tutorial.id} tutorial={tutorial}/>
				})}
				
			</div>
		</section>
	)
}

export const query = graphql`
query GetLatest {

  allBlogJson(sort: {fields: publishedAt, order: DESC}, limit: 3) {
    nodes {
      id
      image
      title
      shortId
      content
      lastchangeAt
      publishedAt
      publishType
      lastchangeuser {
        name
        photo
        userpath
      }
    }
  }

  allTutorialsJson(sort: {fields: id, order: DESC}, limit: 3) {
    nodes {
      slug
      id
      graphics_library
      card_image
      author
      avatar
      description
      title
      window_library
      repository
      language
      serial
    }
  }
  
}
`
